import $axios from './apiConnection'
import parseCatch from '@/helpers/handleErrors'
import { LanguageListApiResponse, TagsListApiResponse, TagsListRequestBody } from '@/types/api'
import env from '@/env'

export const LanguageApi = {
    async getAll () {
        try {
            const { Data } = await $axios.post('/Language/List/', {}) as LanguageListApiResponse

            return Data
        } catch (e) {
            parseCatch(e, false)
        }
    }
}

export const ContentsApi = {
    async getAll () {
        try {
            const payload: TagsListRequestBody = {}

            if (env.VITE_APP_REQUEST_DOMAIN) {
                payload.Domain = env.VITE_APP_REQUEST_DOMAIN
            }

            const { Data } = await $axios.post('/Contents/TagsList/', payload) as TagsListApiResponse

            return Data
        } catch (e) {
            parseCatch(e, false)
        }
    }
}
